/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper, Box, Typography, Grid, Link, Stack,
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { useHistory } from 'react-router-dom';
import Input from '../../components/input';
import logo from '../../assets/logo.png';
import Cadastro from './Cadastro';
import Forgot from './Forgot';
import ButtonTemplate from '../../components/Button/Button';
import { LoginStore, LinksStore } from '../../services/zustandProvider';
import { LoginModel, ValidarEmail, RetornoLogin } from '../models';
import { getEmailTermoConsentimento, LoginAPI } from '../../services/loginAPI';
import { LoginButton } from './Components/LoginButton';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#4c5c68 !important',
    padding: 30,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  ou: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: 'white',
    width: 150,
    height: 6,
    marginTop: 30,
    marginBottom: 30,
  },
}));

const usuario = {
  nome: 'Matheus',
  id: 1,
  eMail: 'matheus-fsilva@hotmail.com',
};

export default function Login():JSX.Element {
  const { setLog, setUserAtivo } = LoginStore();
  const { LinkSite, LinkPoliticas, Imagem } = LinksStore();
  const [forgot, setForgot] = useState(false);
  const [loginData, setLoginData] = useState(new LoginModel());
  const [errorEmail, setErrorEmail] = useState({
    status: false,
    massage: '',
  });
  const [errorSenha, setErrorSenha] = useState({
    status: false,
    massage: '',
  });
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const [emailTermoConsentimento, setEmailTermoConsentimento] = useState('');

  async function Sign() {
    setLoading(true);
    const loginResponse = await LoginAPI(loginData);
    if (loginResponse.sucesso) {
      console.log(loginResponse.dados?.dadosToken.token);
      localStorage.setItem('ptt:User', JSON.stringify(loginResponse.dados?.dadosUsuario));
      localStorage.setItem('ptt:Token', loginResponse.dados?.dadosToken.token ? loginResponse.dados?.dadosToken.token : '');
      setLog(true);
      setUserAtivo(loginResponse.dados?.dadosUsuario);
      if ((loginResponse?.dados?.dadosUsuario?.confirmarEmail !== 'Sim') || (loginResponse?.dados?.dadosUsuario?.confirmarDPO !== 'Sim')) {
        history.push('/Cadastro');
      } else {
        history.push('/Dash');
      }
    } else if (loginResponse.erros[0].propertyName === 'Email') {
      console.log('Email');
      setErrorSenha({ status: true, massage: '' });
      setErrorEmail({ status: true, massage: loginResponse.erros[0].errorMessage });
    } else if (loginResponse.erros[0].propertyName === 'Senha') {
      console.log('Senha');
      setErrorSenha({ status: true, massage: loginResponse.erros[0].errorMessage });
      setErrorEmail({ status: false, massage: '' });
    } else if (loginResponse.erros[0].propertyName === 'EmailSenha') {
      console.log('EmailSenha');
      setErrorSenha({ status: true, massage: loginResponse.erros[0].errorMessage });
      setErrorEmail({ status: true, massage: loginResponse.erros[0].errorMessage });
    } else {
      console.log('consexão');
      setErrorSenha({ status: true, massage: loginResponse.erros[0].errorMessage });
      setErrorEmail({ status: true, massage: loginResponse.erros[0].errorMessage });
    }
    setLoading(false);
  };

  const validarEsqueciSenha = () => {
    if (loginData.email === '') {
      setErrorEmail({ status: true, massage: 'Digite um e-mail para envio de uma nova senha!' });
      return;
    }

    if (!ValidarEmail(loginData.email)) {
      setErrorEmail({ status: true, massage: 'Digite um e-mail valido!' });
      return;
    }

    setErrorEmail({ status: false, massage: '' });
    setForgot(true);
  };

  useEffect(() => {
    setLog(false);
    (async () => {
      const emailReponse = await getEmailTermoConsentimento();
      if (emailReponse.sucesso && emailReponse.dados) {
        setEmailTermoConsentimento(emailReponse.dados.email);
      }
    })();
  }, []);
  return (
    <Box sx={{
      height: '100%',
      width: 1,
      alignItems: 'center',
    }}
    >
      <Box sx={{
        '& > :not(style)': {
          width: '100%',
          height: 100,
          position: 'relative',
          zIndex: 1200,
          backgroundColor: 'white',
          // display: 'none',
        },
      }}
      >
        <Grid container>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <GroupIcon sx={{
              fontSize: '50px',
              color: '#4c5c68',
              marginRight: '5px',
            }}
            />
            <Typography sx={{
              fontSize: { xs: '4vw', sm: '2vw', xl: '1.5vw' },
              color: '#4c5c68',
              lineHeight: '0.9',
              fontWeight: 'bold',
            }}
            >
              Portal do
              {' '}
              <br />
              Titular de dados
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', marginLeft: 'auto', alignItems: 'center' }}>
            <img src={`data:image;charset=utf-8;base64, ${Imagem}`} alt="logo" style={{ marginLeft: 'auto', width: 'auto', height: 80 }} />
          </Grid>
        </Grid>

      </Box>
      <Box
        sx={{
          // display: 'flex',
          flexWrap: 'wrap',
          marginTop: 'auto',
          '& > :not(style)': {
            m: 'auto',
            marginTop: 'auto',
            maxWidth: 350,
            width: '80vw',
            alignItems: 'center',
          },
        }}
      >
        <Paper className={classes.paper}>
          {
                !forgot ? (
                  <>
                    <Box sx={{ width: '100%' }}>
                      <Input
                        id="E-mail"
                        labelSuperior="E-mail"
                        name="E-mail"
                        placeHolder="E-mail"
                        inputColor="white"
                        autoFocus
                        fullWidth
                        variant="outlined"
                        value={loginData.email}
                        onChange={(e: any) => setLoginData((prevState) => (
                          { ...prevState, email: e.target.value }
                        ))}
                        error={errorEmail.status}
                        mensagem={errorEmail.massage}
                      />
                      <Input
                        name="senha"
                        labelSuperior="Senha"
                        type="password"
                        placeHolder="Senha"
                        inputColor="white"
                        id="senha"
                        variant="outlined"
                        fullWidth
                        value={loginData.senha}
                        onChange={(e: any) => setLoginData((prevState) => (
                          { ...prevState, senha: e.target.value }
                        ))}
                        error={errorSenha.status}
                        mensagem={errorSenha.massage}
                      />
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <ButtonTemplate variante="none" onClick={validarEsqueciSenha}>
                          <Typography sx={{ color: '#bdbdbd' }}>Esqueci minha senha</Typography>
                        </ButtonTemplate>
                      </Stack>
                      <Box sx={{ textAlign: 'center' }}>
                        <ButtonTemplate
                          type="submit"
                          cor="cyan"
                          variante="loading"
                          tonalidade={800}
                          className={classes.submit}
                          size="large"
                          loading={loading}
                          onClickLoading={() => Sign()}
                        >
                          Logar
                        </ButtonTemplate>
                        {/* <LoginButton
                          botaoComLoading={false}
                        >
                          Login
                        </LoginButton> */}
                      </Box>
                    </Box>
                    <div style={{ display: 'flex' }}>
                      <div className={classes.ou} />
                      <Typography sx={{
                        margin: 'auto',
                        color: 'white',
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: '10px',
                        marginRight: '10px',
                        fontSize: '25px',
                      }}
                      >
                        ou
                      </Typography>
                      <div className={classes.ou} />
                    </div>
                    <Cadastro emailContato={emailTermoConsentimento} />
                  </>
                ) : (
                  <Forgot
                    back={() => setForgot(false)}
                    loginData={loginData}
                    setLoginData={setLoginData}
                  />
                )
            }
        </Paper>
        <Box sx={{
          padding: '0px',
          maxWidth: '350px !important',
          width: '80vw !important',
        }}
        >
          <Typography
            sx={{
              fontSize: '15px',
              maxWidth: '350px !important',
              width: '80vw !important',
              marginLeft: '30px',
            }}
            align="right"
          >
            Para maiores informações sobre LGPD, consulte
            {' '}
            <Link href={LinkSite} target="_blank">nossa página</Link>
            {' '}
            e
            {' '}
            <Link href={LinkPoliticas} target="_blank">nossa Política de Privacidade</Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
